import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'order-from-client',
  templateUrl: './templates/order-from-client.component.html',
  styleUrls: ['./styles/order-from-client.component.css']
})
export class OrderFromClientComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/order-from-client.component.ts